import {jsx as _jsx} from "react/jsx-runtime";import Menu from '../../../../components/Menu'
import MenuItem from '../../../../components/MenuItem'
import useAtmosphere from '../../../../hooks/useAtmosphere'


import RemoveIntegrationProviderMutation from '../../../../mutations/RemoveIntegrationProviderMutation'
import {Duration} from '../../../../types/constEnums'







const MSTeamsConfigMenu = (props) => {
  const {menuProps, mutationProps, providerId} = props
  const {onError, onCompleted, submitMutation, submitting} = mutationProps
  const atmosphere = useAtmosphere()

  const removeMSTeamsAuth = () => {
    if (submitting) return
    submitMutation()
    // wait for the portal to animate closed before removing, otherwise it'll stick around forever
    setTimeout(() => {
      RemoveIntegrationProviderMutation(atmosphere, {providerId}, {onCompleted, onError})
    }, Duration.PORTAL_CLOSE)
  }
  return (
    _jsx(Menu, { ariaLabel: 'Configure your Microsoft Teams integration', ...menuProps, children: 
      _jsx(MenuItem, { label: "Remove Microsoft Teams"  , onClick: removeMSTeamsAuth,} )
    })
  )
}

export default MSTeamsConfigMenu
